/**
 * Fixed page backdrop for "Re:Humanize the Web": the word "human" written in
 * many scripts (ひと, HOMO, 사람, 人, ἄνθρωπος, मनुष्य…) drifting over the
 * navy ground — the same glyph artwork as the ywc21-landing hero.
 * Purely decorative.
 */
export default function NightSky() {
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-surface"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_-10%,rgba(70,134,210,0.22)_0%,rgba(70,134,210,0.06)_38%,transparent_62%)]" />
      <img
        src="/ywc21/hero-glyphs.webp"
        alt=""
        draggable={false}
        className="absolute left-1/2 top-1/2 h-full min-h-[640px] w-auto min-w-full max-w-none -translate-x-1/2 -translate-y-1/2 object-cover opacity-25"
      />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_120%,var(--surface-deep)_0%,transparent_58%)]" />
    </div>
  )
}
